export const COMPANY = {
  name: "Magit S.r.l.",
  legal: "Magit di Gianfrancesco Maurizio S.r.l.",
  email: "magitimpianti@libero.it",
  pec: "magit_sas@pec.it",
  phoneDisplay: "+39 081 1957 1902",
  phoneRaw: "+3908119571902",
  whatsapp:
    "https://wa.me/3908119571902?text=Buongiorno%20Magit%2C%20vorrei%20richiedere%20informazioni%20%2F%20un%20preventivo.",
  address: "Via Francesco Provenzale, 3 — 80141 Napoli",
  piva: "06482811210",
  hours: "Lun – Ven / 8:00 – 18:00",
};

export const IMAGES = {
  electrical:
    "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  hvac:
    "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  poligono: "https://images.unsplash.com/photo-1761144438625-196d586f54d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  quadri:
    "https://images.unsplash.com/photo-1635335874521-7987db781153?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  efficientamento:
    "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  napoli:
    "https://images.unsplash.com/photo-1676945012038-a2792172cd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Servizi", to: "/servizi" },
  { label: "Progetti", to: "/progetti" },
  { label: "SHOP", to: "/shop", highlight: true },
  { label: "Contatti", to: "/contatti" },
];

export const PILLARS = [
  {
    n: "01",
    title: "L'Approccio",
    text: "Ogni impianto nasce da un progetto. Analizziamo, dimensioniamo e documentiamo prima di intervenire, per consegnare soluzioni durature e conformi.",
  },
  {
    n: "02",
    title: "L'Esperienza",
    text: "Dal 2009 realizziamo impianti per il settore civile, industriale e per enti pubblici. Tecnici specializzati che conoscono ogni dettaglio del mestiere.",
  },
  {
    n: "03",
    title: "La Precisione",
    text: "Non esistono margini nell'impiantistica. Lavoriamo secondo normativa, con materiali certificati e collaudi rigorosi su ogni intervento.",
  },
];

export const STATS = [
  { value: "2009", label: "Anno di fondazione" },
  { value: "3", label: "Aree di specializzazione" },
  { value: "100%", label: "A norma e certificati" },
  { value: "24/7", label: "Assistenza tecnica" },
];

export const SERVICES = [
  {
    id: "elettrici",
    n: "01",
    title: "Impiantistica Elettrica",
    short: "Progettazione, realizzazione e certificazione di impianti civili e industriali a norma.",
    text: "Progettazione, realizzazione e certificazione di impianti elettrici civili e industriali. Dalla singola abitazione al grande stabilimento produttivo, con documentazione completa a norma.",
    bullets: ["Impianti civili e industriali", "Quadri elettrici e cabine", "Certificazioni e dichiarazioni di conformità", "Efficientamento e domotica"],
    image: IMAGES.electrical,
  },
  {
    id: "clima",
    n: "02",
    title: "Climatizzazione & Condizionamento",
    short: "Sistemi HVAC efficienti per il comfort e la resa energetica di ogni ambiente.",
    text: "Sistemi HVAC efficienti per il comfort e la resa energetica di ogni ambiente. Progettiamo e installiamo soluzioni su misura per uffici, abitazioni e spazi industriali.",
    bullets: ["Impianti VRF/VRV e split", "Pompe di calore", "Trattamento aria e ventilazione", "Manutenzione programmata"],
    image: IMAGES.hvac,
  },
  {
    id: "poligoni",
    link: "/manutenzione-poligoni-di-tiro",
    n: "03",
    title: "Manutenzione Poligoni di Tiro",
    short: "Un servizio specialistico e certificato, unico in tutta Italia.",
    text: "Un servizio specialistico e certificato, unico in tutta Italia. Curiamo impianti, sicurezza e manutenzione tecnica di poligoni di tiro per enti pubblici e privati.",
    bullets: ["Manutenzione impianti dedicati", "Sicurezza e conformità normativa", "Interventi specialistici certificati", "Assistenza continuativa"],
    image: IMAGES.poligono,
  },
];

export const SECTORS = [
  { n: "01", title: "Civile", text: "Abitazioni, condomini e strutture residenziali." },
  { n: "02", title: "Industriale", text: "Capannoni, stabilimenti e impianti produttivi." },
  { n: "03", title: "Enti Pubblici", text: "Amministrazioni, scuole e strutture pubbliche." },
  { n: "04", title: "Poligoni di Tiro", text: "Manutenzione specialistica certificata." },
];

export const VALUES = [
  { title: "A regola d'arte", text: "Ogni intervento rispetta normative e standard tecnici, senza compromessi sulla qualità." },
  { title: "Materiali certificati", text: "Selezioniamo componenti affidabili e certificati per impianti duraturi nel tempo." },
  { title: "Squadra specializzata", text: "Tecnici formati che seguono il progetto dal sopralluogo al collaudo finale." },
];

export const PROJECTS = [
  { id: "industriale", tag: "Industriale", title: "Impianto elettrico industriale", place: "Napoli — Italia", image: IMAGES.electrical },
  { id: "clima-uffici", tag: "Climatizzazione", title: "Climatizzazione uffici direzionali", place: "Italia", image: IMAGES.hvac },
  { id: "poligono", tag: "Specialistico", title: "Manutenzione poligono di tiro", place: "Napoli — Italia", image: IMAGES.poligono },
  { id: "quadri", tag: "Civile", title: "Quadri elettrici e cabine", place: "Italia", image: IMAGES.quadri },
  { id: "efficienza", tag: "Efficienza", title: "Efficientamento energetico", place: "Napoli — Italia", image: IMAGES.efficientamento },
  { id: "pubblici", tag: "Enti Pubblici", title: "Impianti per strutture pubbliche", place: "Italia", image: IMAGES.napoli },
];
